export const HOME_PAGE = "首页"










// WEBPACK FOOTER //
// ./src/constant/analysis.js